import { render, staticRenderFns } from "./highlightMenu.vue?vue&type=template&id=af71bc9c&scoped=true&"
import script from "./highlightMenu.vue?vue&type=script&lang=js&"
export * from "./highlightMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af71bc9c",
  null
  
)

export default component.exports